/** Parses MeshInstance3D nodes from TSCN. */
import { parseGeometryInstance3D } from '../geometryinstance3d/parser';
import { parseOptionalInt } from '../../../parser/valueParsers';
import { indexedKeyRegex } from '../../../godot/classdb/indexedKey.js';
import { stringToInt } from '../../../godot/string/string.js';
import { holdsResource } from '../../../godot/scene/resourceLiteral.js';
/** Assigns only a present value: the optional readers already drop an absent or unreadable one. */
function assignIfDefined(target, key, value) {
    if (value !== undefined)
        target[key] = value;
}
/**
 * `_set` reads the index with a bare `get_slicec('/', 1).to_int()` into an `int`
 * (mesh_instance_3d.cpp:66), so {@link stringToInt} decides the number: `+2` is
 * surface 2, `abc` is surface 0. Unanchored: `get_slicec` ignores the rest
 * (ustring.cpp:941-964), so `surface_material_override/0/extra` names surface 0.
 */
const SURFACE_OVERRIDE_KEY_RE = indexedKeyRegex('^surface_material_override/(#)', 'to_int');
export function parseMeshInstance3D(heading, properties) {
    const geometryProps = parseGeometryInstance3D(heading, properties);
    const surfaceMaterialOverrides = new Map();
    for (const [key, value] of Object.entries(properties)) {
        const indexedMatch = SURFACE_OVERRIDE_KEY_RE.exec(key);
        if (!indexedMatch)
            continue;
        const surfaceIndex = stringToInt(indexedMatch[1]);
        // `if (idx >= surface_override_materials.size() || idx < 0) return false`
        // (mesh_instance_3d.cpp:68). Only the sign is knowable here: the renderer resolves
        // the surface count from the mesh.
        if (surfaceIndex < 0)
            continue;
        surfaceMaterialOverrides.set(surfaceIndex, value);
    }
    const meshInstance3DProps = {
        ...geometryProps,
        surfaceMaterialOverrides,
    };
    if (holdsResource(properties.mesh)) {
        meshInstance3DProps.mesh = properties.mesh;
    }
    if (holdsResource(properties.material_override)) {
        meshInstance3DProps.materialOverride = properties.material_override;
    }
    if (holdsResource(properties.material_overlay)) {
        meshInstance3DProps.materialOverlay = properties.material_overlay;
    }
    assignIfDefined(meshInstance3DProps, 'giMode', parseOptionalInt(properties.gi_mode));
    assignIfDefined(meshInstance3DProps, 'giLightmapScale', parseOptionalInt(properties.gi_lightmap_scale));
    if (properties.skeleton) {
        meshInstance3DProps.skeleton = properties.skeleton;
    }
    if (holdsResource(properties.skin)) {
        meshInstance3DProps.skin = properties.skin;
    }
    return meshInstance3DProps;
}
//# sourceMappingURL=parser.js.map